/**
 * sg-upload directive
 *
 * Directive that controls the upload. It defines the droppable area. The
 * sg-upload-input directive must be added as a child to render the upload link
 * progress bars and existing files. The direcives share scope.
 *
 * @param {function} files-changed - callback that notifies caller of uploads or removed uploads
 * @param {string} uploaded-files - object path to the existing files on the scope.
 * (e.g. if scope = { element: { uploads: [files] } } then uploaded-files="element.uploads")
 * @param {string} endpoint - url path to route that can handle multipart/form-data (http post).
 *
 */
(function () {

  'use strict';

  angular
    .module('specsguardApp')
    .directive('sgUpload', sgUpload);

  function sgUpload () {

    return {
      restrict: 'E',
      templateUrl: 'app-legacy/components/sg-upload/sg-upload.html',
      transclude: true,
      controller: 'sgUploadController',
      controllerAs: 'vm',
      bindToController: {
        filesChangedCb: '&',
        uploadedFiles: '=',
        endpoint: '@',
        accepted: '@',
      }
    };

  }
})();
